// TableMenu.jsx
// Dropdown menu for table-related actions

import React, {useState} from "react";
import {Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";

/**
 * Table menu dropdown component
 * Groups all table-related actions into a single menu
 */
function TableMenu({action}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (item) => {
        item.run();
        handleClose();
    };

    return (
        <>
            <Tooltip title={action.label} arrow>
                <IconButton
                    onClick={handleClick}
                    color={open ? "primary" : "default"}
                    sx={{
                        bgcolor: open ? "action.selected" : "transparent",
                    }}
                >
                    {action.icon}
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {action.items.map((item) => {
                    if (item.separator) {
                        return <Divider key={item.key}/>;
                    }

                    const enabled = item.enabled();
                    return (
                        <MenuItem
                            key={item.key}
                            onClick={() => handleItemClick(item)}
                            disabled={!enabled}
                        >
                            <ListItemIcon>
                                {item.icon}
                            </ListItemIcon>
                            <ListItemText>{item.label}</ListItemText>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
}

export default TableMenu;
